import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { ArrowRight, Hourglass } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { SendAssessmentDialog } from "@/pages/assessments/SendAssessmentDialog";

const TAB = { send_work_sample: "work-sample", prepare_interview: "interview", decide: "overview", export: "overview" };

export function NextActionButton({ row, canAct, size = "sm" }) {
  const nav = useNavigate();
  const qc = useQueryClient();
  const [send, setSend] = useState(false);
  const [busy, setBusy] = useState(false);
  const n = row.next;
  const refresh = () => ["workspace", "ranked", "inbox-actions", "job"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  const profile = (tab) => nav(`/app/candidates/${row.candidate_id}/${tab === "worksample" ? "work-sample" : tab || "overview"}`);
  if (!n.action) return (
    <span className="inline-flex items-center gap-1 text-xs text-ink-muted" title={n.why} data-testid={`next-${row.application_id}`}>
      {n.waiting && <Hourglass size={13} aria-hidden />}{n.label}</span>
  );
  const go = async () => {
    if (!canAct || n.action === "open") return profile(n.tab);
    if (n.action === "shortlist") {
      setBusy(true);
      try { await api.post("/applications/move", { application_ids: [row.application_id], stage: "screen_shortlist" }); toast.success(`${row.name} shortlisted`); refresh(); }
      catch (e) { toast.error(errMsg(e)); }
      return setBusy(false);
    }
    if (n.action === "send_assessment") return setSend(true);
    profile(TAB[n.action] || n.tab);
  };
  return (
    <>
      <Button size={size} variant={n.action === "open" ? "outline" : "default"} disabled={busy} onClick={go} title={n.why} data-testid={`next-${row.application_id}`}>
        {canAct || n.action === "open" ? n.label : "View"} <ArrowRight size={14} /></Button>
      {send && <SendAssessmentDialog jobId={row.job_id} applicationIds={[row.application_id]} open={send} onClose={() => { setSend(false); refresh(); }} onSent={() => {}} />}
    </>
  );
}
